/**
 * ホテラバ(hl2)専用商品一覧の独立バンドル。
 *
 * ## 設計方針: 新フロントへの移植を前提とした独立モジュール
 *
 * この一覧は将来、新フロント(BFFを直叩きするSPA)へ移植する予定で、本リポジトリ上の実装は過渡期のもの。
 * 移植の障害になるため、既存モジュールへの依存は意図的に最小限に絞る:
 *
 * - 依存してよいもの: 薄いインフラ(ApiClient / log / localStorageキーのregistry)、
 *   既存一覧とのUX連続性が要件になる共有(画像種別のlocalStorage永続化)、
 *   外部契約の符号化を二重管理しないための依存なし純粋モデル(画像suffixのThumbnailUrl)、
 *   自前実装のコストが高い共通部品HalfModal(シート・focus trap・背景ロック)
 * - 依存しないもの: Vuex store・mixin・上記以外の既存UIコンポーネント。既存に類似実装があっても
 *   共通化はせず、このバンドル内での重複実装を許容する
 *   (例: ImageTypeSwitcherは既存のContactLensImageTypeSwitcherと同種のUIだが独立実装)
 *
 * URL語彙をBFF語彙と同一視する判断も同じ将来像に基づく(model/condition.ts のdocblock参照)。
 */
import App from '@hl-itemlist/App.vue'
import Vue from 'vue'

Vue.config.productionTip = false

const element = document.getElementById('hl-itemlist-app')

if (element) {
  new Vue({
    render: h => h(App),
  }).$mount(element)
}
